import { useEffect, useState } from 'react';

import { LoadingSpinner } from 'twyne-new.ui'

import { useGrid } from '@Components/Grid/context';

import InfiniteScroll from './InfiniteScroll';

export default function Pagination() {
  const { store: { loading, collections: { hasNextPage } }, state: { options: { nextPage } } } = useGrid()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!loading && isLoading) {
      setTimeout(() => {
        setIsLoading(false)
      }, 3000)
    }

    setIsLoading(loading)
  }, [loading, isLoading])

  const shouldLoad = hasNextPage && !loading && !isLoading

  return <div className="flex w-full justify-center items-center h-14">
    {shouldLoad && <InfiniteScroll onVisit={nextPage} hasMore={shouldLoad} />}
    {loading && <LoadingSpinner />}
  </div>
}
